import styles from './Topbar.module.css';

interface TopbarProps {
  title: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

export function Topbar({ title, ctaLabel, onCtaClick }: TopbarProps) {
  return (
    <header className={styles.topbar}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.searchBox}>
        <span>🔍</span>
        <input type="text" placeholder="検索..." />
      </div>
      {ctaLabel && (
        <button className={styles.btn} onClick={onCtaClick}>
          + {ctaLabel}
        </button>
      )}
    </header>
  );
}
